import { ICON_NAMES } from '@belong/types';
import { StyledIcon } from './Icons.styles';
import CONTENT from './content.json';

export const OpenInNewTabIcon: React.FC = () => {
  return <StyledIcon name={ICON_NAMES.NewWindow} size="xxsmall" ariaLabel={CONTENT.openInNewTab} />;
};
